export const getEmailSectionContainer = ({
  title,
  icon,
  content,
  marginTop = false,
}) => `
        <!--[if mso | IE]><td class="" style="width:598px;" ><![endif]-->
        <div
          class="mj-column-per-100 mj-outlook-group-fix"
          style="
            font-size: 0;
            line-height: 0;
            text-align: left;
            display: inline-block;
            width: 100%;
            direction: ltr;
            ${marginTop ? `margin-top: ${marginTop};` : ""}
          "
        >
          <!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation" ><tr><td style="vertical-align:top;width:598px;" ><![endif]-->
          <div
            class="mj-column-per-100 mj-outlook-group-fix"
            style="
              font-size: 0px;
              text-align: left;
              direction: ltr;
              display: inline-block;
              vertical-align: top;
              width: 100%;
            "
          >
            <table
              border="0"
              cellpadding="0"
              cellspacing="0"
              role="presentation"
              style="vertical-align: top"
              width="100%"
              data-testid="email-section-container${
                title ? `-${title.toLowerCase().replaceAll(" ", "-")}` : ""
              }"
            >
              <tbody>
                <tr>
                  <td
                    align="left"
                    style="
                      font-size: 0px;
                      padding: 10px 25px;
                      padding-top: 4px;
                      padding-right: 8px;
                      padding-bottom: 4px;
                      padding-left: 8px;
                      word-break: break-word;
                    "
                  >
                    <div
                      style="
                        font-family: Roboto, Arial;
                        font-size: 12px;
                        font-weight: 600;
                        line-height: 1;
                        text-align: left;
                        color: #000000;
                      "
                    >
                      <span
                        class="section-header-icon"
                        style="
                          background-color: #006064;
                          width: 14px;
                          height: 14px;
                          border-radius: 50%;
                          display: inline-block;
                          text-align: center;
                          color: #ffffff;
                          font-size: 10px;
                          line-height: 14px;
                          margin-right: 4px;
                        "
                        >${icon}</span
                      >${title}
                    </div>
                  </td>
                </tr>
                ${content}
              </tbody>
            </table>
          </div>
          <!--[if mso | IE]></td></tr></table><![endif]-->
        </div>
        <!--[if mso | IE]></td><![endif]-->
`;
